var LG_BREAKPOINT = "(min-width: 64rem)";
var menuElement = document.getElementById("global-menu");
var triggerElement = document.querySelector('[commandfor="global-menu"]');
if (menuElement instanceof HTMLDialogElement && triggerElement) {
    var detailsElements_1 = menuElement.querySelectorAll("details");
    var mediaQuery = window.matchMedia(LG_BREAKPOINT);
    function syncMenuTriggerState() {
        var isOpen = menuElement.open;
        triggerElement.setAttribute("aria-expanded", String(isOpen));
        triggerElement.setAttribute("aria-label", isOpen ? "メニューを閉じる" : "メニューを開く");
        triggerElement.setAttribute("command", isOpen ? "request-close" : "--show");
    }
    function handleBreakpoint(e) {
        detailsElements_1.forEach(function (detail) {
            detail.open = e.matches;
        });
    }
    menuElement.addEventListener("command", function (e) {
        if (e.command === "--show") {
            menuElement.show();
        }
    });
    menuElement.addEventListener("close", syncMenuTriggerState);
    triggerElement.addEventListener("click", function () {
        window.requestAnimationFrame(syncMenuTriggerState);
    });
    menuElement.addEventListener("click", function (e) {
        var _a, _b;
        var link = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, "a");
        if (link && menuElement.open) {
            menuElement.close();
        }
    });
    mediaQuery.addEventListener("change", handleBreakpoint);
    syncMenuTriggerState();
    handleBreakpoint(mediaQuery);
}
